import { render, staticRenderFns } from "./DblogsTable.vue?vue&type=template&id=2e55183a"
import script from "./DblogsTable.vue?vue&type=script&lang=js"
export * from "./DblogsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports